import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black py-16 px-4 border-t border-border-light" data-id="element-145">
      <div className="max-w-4xl mx-auto text-center" data-id="element-146">
        <div className="font-display text-white text-3xl sm:text-4xl font-bold tracking-widest mb-6 flex items-center justify-center gap-3 uppercase" data-id="element-147">
          <span className="text-4xl" data-id="element-148">🏋️‍♂️</span>{' '}
          <span data-id="element-149">
            FUNCTIONAL <span className="text-primary" data-id="element-150">CLÉ EN MAIN</span>
          </span>
        </div>

        <p className="text-text-sec text-sm tracking-[0.2em] mb-2 uppercase font-bold" data-id="element-151">
          EduLabs France
        </p>

        <p className="text-white/90 text-base sm:text-lg leading-relaxed mb-10 max-w-xl mx-auto font-medium" data-id="element-152">
          Le système premium pour coachs functional modernes.
        </p>

        <div className="flex items-center justify-center gap-6 text-sm text-white/80 mb-10 flex-wrap" data-id="element-153">
          <a href="mailto:support.functionalcleenmain@gmail.com" className="flex items-center gap-2 hover:text-primary transition-colors" data-id="element-154">
            <span data-id="element-155">📧</span> support.functionalcleenmain@gmail.com
          </a>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-border-light to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-156" />

        <p className="text-text-sec text-xs tracking-[0.2em] uppercase" data-id="element-157">
          © FUNCTIONAL CLÉ EN MAIN 2026 — Tous droits réservés.
        </p>
      </div>
    </footer>;
}